import { SectionHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { OneDataCollection } from '@factorialco/factorial-one-react/dist/experimental'
import { OneOnOnesListDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export default function TeamOneOnOneList() {
  const { employee } = useCurrentSession()
  const { navigation } = useNavigation()

  const source = useGraphqlDataSource({
    document: OneOnOnesListDocument,
    mapData: (data) => data.oneOnOnes.oneOnOnesConnection.nodes,
    mapPagination: (data) => ({
      total: Number(data.oneOnOnes.oneOnOnesConnection.totalCount),
    }),
    search: {
      enabled: true,
    },
    mapVariables: ({ search }) => ({
      search,
      excludedParticipantIds: [Number(employee?.id)],
    }),
    itemUrl(item) {
      return navigation.performanceOneOnOnes.oneOnOne.meetings.fullPath({
        oneOnOneId: item.id,
      })
    },
  })

  const formatMeetingDate = (date?: string | null) => {
    if (!date) return '-'
    return dateBackendDateTimeToUI(date)
  }

  return (
    <>
      <SectionHeader
        title={i18n.t('one_on_ones.list_view.team.title')}
        description={i18n.t('one_on_ones.list_view.team.description')}
      />

      <OneDataCollection
        source={source}
        visualizations={[
          {
            type: 'table',
            options: {
              columns: [
                {
                  label: i18n.t('one_on_ones.table.first_participant'),
                  render: (item) => {
                    return {
                      type: 'person',
                      value: {
                        firstName: item.firstParticipant?.firstName ?? '',
                        lastName: item.firstParticipant?.lastName ?? '',
                        src: buildUrl(item.firstParticipant?.avatar?.url),
                      },
                    }
                  },
                },
                {
                  label: i18n.t('one_on_ones.table.second_participant'),
                  render: (item) => {
                    return {
                      type: 'person',
                      value: {
                        firstName: item.secondParticipant?.firstName ?? '',
                        lastName: item.secondParticipant?.lastName ?? '',
                        src: buildUrl(item.secondParticipant?.avatar?.url),
                      },
                    }
                  },
                },
                {
                  label: i18n.t('one_on_ones.table.last_meeting'),
                  render: (item) => ({
                    type: 'text',
                    value: formatMeetingDate(item.lastMeeting?.startTime),
                  }),
                },
                {
                  label: i18n.t('one_on_ones.table.next_meeting'),
                  render: (item) => ({
                    type: 'text',
                    value: formatMeetingDate(item.upcomingMeeting?.startTime),
                  }),
                },
              ],
            },
          },
        ]}
      />
    </>
  )
}
